export default {
    state: {
        tags: []
    },
    mutations: {
        setTags (state, payload) {
            state.tags = payload
        }
    },
    actions: {
        getTags (context) {
            return new Promise((resolve, reject) => {
                this._vm.axios.get('/api/tags')
                .then(response => {
                    let tags = []

                    if (response.data) {
                        tags = response.data
                    }

                    context.commit('setTags', tags)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        }
    }
}
